import Input from '../../floating-placeholder-input/input';
import React from 'react';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Button } from 'components';

interface Props {
	search: string;
	onSearch: (value: string) => void;
	next: () => void;
	previous: () => void;
	activeIndex: number;
	total: number;
	placeholder?: string;
}

const SearchInput: React.FC<Props> = ({ search, onSearch, next, previous, activeIndex, total, placeholder }) => {
	const onChange = event => {
		onSearch(event.target.value);
	};

	return (
		<div className="search-input">
			<Input
				className="search-input-input"
				placeholder={placeholder ?? 'Search'}
				value={search}
				onChange={onChange}
			/>
			<div className="icons-wrapper">
				{search !== '' && (
					<>
						<span className="count">{`${total ? activeIndex + 1 : 0}/${total}`}</span>
						<Button onClick={previous} type="link" className="previous-icon">
							<BringgIcon iconName={BringgFontIcons.ChevronUp} />
						</Button>
						<Button onClick={next} type="link" className="next-icon">
							<BringgIcon iconName={BringgFontIcons.Chevron} />
						</Button>
					</>
				)}
				<BringgIcon iconName={BringgFontIcons.Search} className="search-icon" />
			</div>
		</div>
	);
};

export default SearchInput;
